/* eslint-disable camelcase */
import React, {
  useCallback, useRef, useState,
} from 'react';
import {
  Card, Col, Modal, Row,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBuildingColumns, faPhone, faSitemap, faUserGear,
  faChessRook, faEnvelope,
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import LogcaLogin from '../../../containers/services/SignKey/auth';
import corner3 from '../../../assets/img/icons/spot-illustrations/corner-3.png';
import Background from '../../blanks/common/Background';
import Flex from '../../blanks/common/Flex';
import IconButton from '../../blanks/common/IconButton';
import api from '../../../api/req';

const addToLog = async (cData) => {
  const response = await api.post$('/api/logica/save-to-log/', () => null, {
    data_key_user: cData,
  });

  if (response.ok) {
    return { success: true };
  }
  return false;
};

function AuthLogikaForm({ setSuccessLogica, setUser }) {
  const [showLogicaLoginModal, setShowLogicaLoginModal] = useState(true);
  const userData = useRef({
    userName: '',
    orgName: '',
    city: '',
    Edrpou: 0,
    phone: '',
    EMail: '',
    inspectionCode: 0,
    subjOrg: '',
    netCode: 0,
    changeDataByForm: {
      phone: '',
      login: '',
      EMail: '',
      firstName: '',
      lastName: '',
      netCode: 0,
      inspectionCode: 0,
      Edrpou: 0,
    },
  });

  const getUserData = useCallback((cData) => {
    const { logikaData, keyData } = cData;

    const res = {
      changeDataByForm: {
        phone: '',
        login: '',
        EMail: '',
        firstName: '',
        lastName: '',
        kvk: 0,
        netCode: 0,
        inspectionCode: 0,
        Edrpou: 0,
      },
    };

    if (keyData) {
      addToLog(keyData);
      if (Array.isArray(keyData)) {
        const lastEl = keyData[keyData.length - 1];
        const { infoEx } = lastEl;
        try {
          if (infoEx) {
            const {
              subjPhone, subjEMail, subjFullName, subjLocality, subjOrg,
              organizationId, organizationName, subjCN, subject, subjEDRPOUCode,
            } = infoEx;

            const userName = (subjFullName) || subject;

            res.Edrpou = organizationId || subjEDRPOUCode;
            res.phone = subjPhone;
            res.changeDataByForm.phone = subjPhone;

            res.EMail = subjEMail;
            res.subjOrg = subjOrg.replace(/\s/g, '') ? (subjOrg.replace(/\s/g, '') !== '') : organizationName;
            res.changeDataByForm.EMail = subjEMail;
            res.changeDataByForm.login = subjEMail.slice(0, subjEMail.indexOf('@'));

            res.city = subjLocality;

            res.userName = userName || subjCN;
            const arrName = res.userName ? res.userName.split(' ') : [];
            res.changeDataByForm.lastName = (arrName.length > 0) ? arrName[0] : '';
            res.changeDataByForm.firstName = `${(arrName.length > 1) ? arrName[1] : ''} ${(arrName.length > 2) ? arrName[2] : ''}`;
          }
        } catch {
          addToLog(infoEx);
        }
      }
    }

    if (logikaData) {
      const {
        Edrpou, Locbudcode, Name, Net_Code, success, kvk, phone, EMail, userName,
      } = logikaData;

      // console.log('logikaData', logikaData);

      try {
        setShowLogicaLoginModal(false);
        setSuccessLogica(success);
        if (Edrpou && (Edrpou.replace(/\s/g, '') !== '')) {
          res.Edrpou = Edrpou.replace(/\s/g, '');
        }

        const phoneLogica = phone || '';
        res.phone = res.phone || phoneLogica;

        res.changeDataByForm.phone = res.phone;
        res.changeDataByForm.Edrpou = Edrpou || res.Edrpou;
        res.inspectionCode = Locbudcode;
        res.changeDataByForm.inspectionCode = res.inspectionCode;
        res.orgName = Name;
        res.netCode = Net_Code || res.netCode;
        res.changeDataByForm.netCode = res.netCode;
        res.kvk = kvk;
        res.userName = res.userName || userName;
        res.changeDataByForm.kvk = res.kvk;
        res.EMail = res.EMail || EMail;
      } catch {
        addToLog(logikaData);
      }
    }

    userData.current = {
      ...res,
    };

    setUser(userData.current);
  }, [setSuccessLogica, setUser]);

  // useEffect(() => {
  //   getUserData(a2);
  // }, [getUserData]);

  const hi = (userData.current.userName.replace(/\s/g, '') !== '') ? userData.current.userName : userData.current.orgName;
  const subHi = (userData.current.userName.replace(/\s/g, '') !== '') ? userData.current.orgName : '';

  return (
    <>
      {!userData.current && (
      <>
        <p className="mb-5">Авторизація в системі Logica за допомогою ЕЦП.</p>
        <IconButton
          variant="primary"
          className="ms-auto px-5"
          transform="down-1 shrink-4"
          onClick={() => setShowLogicaLoginModal(true)}
        >
          Авторизація
        </IconButton>
      </>
      )}
      {userData.current && (
      <Card className="h-100">
        <Background image={corner3} className="rounded-soft bg-card" />
        <Card.Header className="z-index-1">

          {hi ? (
            <Row className="justify-content-between align-items-center">
              <Col sm={12} md={12}>
                <h3 className="text-primary mb-1" style={{ textAlign: 'center' }}>
                  { `${hi}, запрошуємо до "Є-Пічник"!`}
                </h3>
              </Col>
            </Row>
          ) : (
            <Row className="justify-content-between align-items-center">
              {/* <Button onClick={() => setShowLogicaLoginModal(true)}> */}
              {/*  Авторизуватись в системі Logica за допомогою ЕЦП */}
              {/* </Button> */}
              <h3 className="text-primary mb-1">
                Запрошуємо до "Є-Пічник"!
              </h3>
            </Row>
          )}

          <h5 className="text-600">{subHi}</h5>
        </Card.Header>
        <Card.Body className="z-index-1">
          <Row className="g-2 h-100 align-items-end">
            <Col sm={6} md={6} key="Auth-Col-City">
              <Flex className="position-relative">
                <div className="icon-item icon-item-xl border rounded-3 shadow-none me-2">
                  <FontAwesomeIcon icon={faChessRook} className="text-primary" />
                </div>
                <div className="flex-1">
                  <h5 className="mb-0 text-1000">{userData.current.city}</h5>
                  <p className="mb-3 fs--2 text-1000 ">Розташування</p>
                </div>
              </Flex>
            </Col>
            <Col sm={6} md={6} key="Auth-Col-City">
              <Flex className="position-relative">
                <div className="icon-item icon-item-xl border rounded-3 shadow-none me-2">
                  <FontAwesomeIcon icon={faBuildingColumns} className="text-warning" />
                </div>
                <div className="flex-1">
                  <h5 className="mb-0 text-1000">{userData.current.Edrpou}</h5>
                  <p className="mb-3 fs--2 text-1000 ">ЄДРПОУ</p>
                </div>
              </Flex>
            </Col>

            <Col sm={6} md={6} key="Auth-Col-City">
              <Flex className="position-relative">
                <div className="icon-item icon-item-xl border rounded-3 shadow-none me-2">
                  <FontAwesomeIcon icon={faPhone} className="text-success" />
                </div>
                <div className="flex-1">
                  <h5 className="mb-0 text-1000">{userData.current.phone}</h5>
                  <p className="mb-3 fs--2 text-1000 ">Телефон</p>
                </div>
              </Flex>
            </Col>
            <Col sm={6} md={6} key="Auth-Col-City">
              <Flex className="position-relative">
                <div className="icon-item icon-item-xl border rounded-3 shadow-none me-2">
                  <FontAwesomeIcon icon={faEnvelope} className="text-success" />
                </div>
                <div className="flex-1">
                  <h5 className="mb-0 text-1000">{userData.current.EMail}</h5>
                  <p className="mb-3 fs--2 text-1000 ">Електронна пошта</p>
                </div>
              </Flex>
            </Col>

            <Col sm={6} md={6} key="Auth-Col-City">
              <Flex className="position-relative">
                <div className="icon-item icon-item-xl border rounded-3 shadow-none me-2">
                  <FontAwesomeIcon icon={faSitemap} className="text-info" />
                </div>
                <div className="flex-1">
                  <h5 className="mb-0 text-1000">{userData.current.inspectionCode}</h5>
                  <p className="mb-3 fs--2 text-1000 ">Код бюджету</p>
                </div>
              </Flex>
            </Col>
            <Col sm={6} md={6} key="Auth-Col-City">
              <Flex className="position-relative">
                <div className="icon-item icon-item-xl border rounded-3 shadow-none me-2">
                  <FontAwesomeIcon icon={faUserGear} className="text-info" />
                </div>
                <div className="flex-1">
                  <h5 className="mb-0 text-1000">{userData.current.netCode}</h5>
                  <p className="mb-3 fs--2 text-1000 ">Код мережі</p>
                </div>
              </Flex>
            </Col>

          </Row>
        </Card.Body>
      </Card>
      )}
      {showLogicaLoginModal && (
      <Modal
        show={showLogicaLoginModal}
        contentClassName="vh-100"
        dialogClassName="my-0"
        onHide={() => setShowLogicaLoginModal(false)}
      >
        <Modal.Header closeButton>
          Авторизація в Logica
        </Modal.Header>
        <Modal.Body>
          <LogcaLogin
            getUserData={getUserData}
            onSuccess={() => setShowLogicaLoginModal(false)}
          />
        </Modal.Body>
      </Modal>
      )}
    </>
  );
}

AuthLogikaForm.propTypes = {
  setSuccessLogica: PropTypes.func,
  setUser: PropTypes.func,
};

AuthLogikaForm.defaultProps = {
  setSuccessLogica: null,
  setUser: null,
};

export default AuthLogikaForm;
